import React, { useCallback } from 'react'
import { useState, useEffect, useRef } from 'react';
import * as flightInfoTypes from './flightInfoTypes'
import * as modalType from '../modal/modalTypes'

const FlightInfo = (props) => {

    var moment = require('moment');

    let {flightDetail, type, onShowModal} = props
    let depEdctDiffTime = props.depEdctDiffTime
    //console.info("shbbdbf", depEdctDiffTime);
    let flightNumber = 'XXX'
    let timeChangedOutbound = ''
    let tailSwapped = ''
    let t0 = props.t0;
    let t0label= props.t0label;
    if (flightNumber != "") {
        flightNumber = flightDetail.FltNum
    } else {
        flightNumber = 'XXX'
    }

    //Check if tail has changed
    function showOldTail() {
        if (flightDetail.PreviousTailNum != null && flightDetail.UncorrectedTailNum != flightDetail.PreviousTailNum) {
            tailSwapped = 'updatedInfo'
            return (<span className="oldTailNumber">/ <strike>{flightDetail.PreviousTailNum}</strike><br /></span>)
        }
    }

    //Show difference if STD is different from ETD
    function showOldTime(direction) {       
        if (direction == flightInfoTypes.INBOUND) {//For inbound flight, compare ETA/STA
            if (flightDetail.STA != flightDetail.ETA && flightDetail.EDCT == null) {
                return (<label>Arriving <span className="oldFlightTime">/ <strike>{flightDetail.STA}</strike><br /></span></label>)
            } 
            else {
                return (<label>Arriving</label>)
            }
        } else
            if (direction == flightInfoTypes.OUTBOUND) {
                if (flightDetail.STD != flightDetail.ETD) {                 //For outbound flight, compare ETD/STD
                    timeChangedOutbound = 'updatedInfo'
                    return (<label>Departing <span className="oldFlightTime">/ <strike>{flightDetail.STD}</strike><br /></span></label>)
                } else if (flightDetail.EDCT != null) {
                    return (<label>Arriving <span className="oldFlightTime">/ <strike>{flightDetail.STD}</strike><br /></span></label>)
                }else {
                    return (<label>Departing</label>)
                }
            }

    }

    function className() {
        return (
            type == flightInfoTypes.OUTBOUND ? 'fi_departing' : 'fi_arriving'

        )
    }

    function station() {        
        return (           
            type == flightInfoTypes.OUTBOUND ?
                <span>{flightDetail.DepAirport} - {flightDetail.ArrAirport}</span> :
                <span>{flightDetail.DepAirport} - {flightDetail.ArrAirport}</span>
        )
    }

    function gate() {
        return (
            type == flightInfoTypes.OUTBOUND ?
                <p>Departure Gate: {flightDetail.DepGate}</p> :
                <p>Arrival Gate: {flightDetail.ArrGate}</p>
        )
    }

    function depArrTime(direction) {
        if (direction == flightInfoTypes.INBOUND) {
            let arrivalTime = flightDetail.ETA;
            if (flightDetail.ATA && flightDetail.ATA != "Invalid date") {
                arrivalTime = flightDetail.ATA;
            }
            return (
                <span data-testid="arrival-time">{arrivalTime}</span>
            )
        } else {
            if (flightDetail.EDCT == null) {
                return (
                    <span>{flightDetail.ETD}</span>
                )
            } else {
                return (
                    <span>{moment(flightDetail.EDCT).subtract(depEdctDiffTime, 'minutes').format('HH:mm')}</span>
                )
            }
        }

    }

    //This is the function that will update a bunch of elements according to their logic per sec

    function useInterval(callback, delay) {
        const savedCallback = useRef();

        // Remember the latest function.
        useEffect(() => {
            savedCallback.current = callback;
        }, [callback]);

        // Set up the interval.
        useEffect(() => {
            function tick() {
                savedCallback.current();
            }
            if (delay !== null) {
                let id = setInterval(tick, delay);
                return () => clearInterval(id);
            }
        }, [delay]);
    }

    //Last Passenger off the plane
    function LastPaxOff() {
        let [paxOff, setPaxOff] = useState('')
        useInterval(() => {
            if (flightDetail.LastPaxOffTime != null) {
                setPaxOff('inactive')
            }
        }, 1000)

        return paxOff
    }

    function getOpsComments() {
        if (flightDetail.flightOpsComments != null) {
            return (
                <a onClick={onClick} className="floatLeft">{flightNumber}</a>
            )
        } else {
            return (<span className="floatLeft">{flightNumber}</span>)
        }
    }

    //carrier code starts here
    function carrierCode(direction) {        
        if (direction == flightInfoTypes.INBOUND) {//For inbound flight carrier code
            if (flightDetail.IATAMarketingcodeInbound != null) {
                return (<span className="flightCode">
                    {flightDetail.IATAMarketingcodeInbound}<br /></span>)
            } 
            else {
                return (<label> </label>)
            }
        } else
            if (direction == flightInfoTypes.OUTBOUND) { //For outbound flight carrier code               
                if (flightDetail.IATAMarketingcodeOutbound != null)
                {
                    return (<span className="flightCode">
                        {flightDetail.IATAMarketingcodeOutbound}<br /></span>)
                } 
                else {
                    return (<label> </label>)
                }
            }

    }
    //carrier code ends here

    const onClick = useCallback(e => onShowModal(modalType.FLIGHT_INFO, flightDetail));
    const edctTime = flightDetail.EDCT != null ? (<div className="warning mtm">Wheels up: {moment(flightDetail.EDCT).format('HH:mm')}</div>) : ''

    function showT0(flightDetail) {
        if (flightDetail.flightDirection == flightInfoTypes.OUTBOUND
            && !flightDetail.terminatorFlight
            && flightDetail.ETD != moment(t0).clone().format('HH:mm')
        ) {
            return (
                <div data-testid="t0-time-stamp">
                    <span alt={t0label}>
                        <b>T0: {moment(t0).clone().format('HH:mm')}</b>
                    </span>
                </div>);
        }
    }

    return (

        <div className={`${className()} ${LastPaxOff()}`}>
            <div className="flightNumberDisplay">
                <div className="flightCode">{carrierCode(type)}</div>
                <div className="flightNumber" >{getOpsComments()}
                    <div className="floatLeft">
                        {showOldTail()}
                        <span className={`tailNumber ${tailSwapped}`}>/ {flightDetail.UncorrectedTailNum}</span></div>

                </div>
            </div>
            {showOldTime(type)}
            <div>
                {station()} / 
                <span className={`flightTime ${timeChangedOutbound}`}>
                    {depArrTime(flightDetail.flightDirection)}
                </span>
            </div>
            {edctTime}
            {showT0(flightDetail)}
        </div>
    )
}

export default FlightInfo